import { Button, Grid, Spinner } from '@chakra-ui/react'
import type { InsuranceParamsTravelDto } from 'BrokerTsLib/src/dtos'
import { SelectionType } from 'BrokerTsLib/src/enums'
import { toDate } from 'BrokerTsLib/src/Utils/formatPrice'
import moment from 'moment'
import { useState } from 'react'

import { DatepickerPopup } from '@/components/DatepickerPopup'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { useOffersTravelContext } from '@/context/OffersTravelProvider'
import { useStepsContext } from '@/context/StepsContext'
import { useWizzardHeader } from '@/context/WizzardHeaderContext'
import { useSelections } from '@/hooks'
import { useUpdateInsuranceStartDate } from '@/hooks/useWizard'

import { InsuranceInfoFormControl } from './InsuranceInfoFormControl'

// import calendarIcon from '@/images/calendar-icon.svg'

export const InsuranceSettingsFormTravel = () => {
  const { isScrolled } = useWizzardHeader()
  const { currentStepId } = useStepsContext()
  const { insuranceParams: ip, insuranceParamsId, refetchInsuranceParams, isDisabled } = useInsuranceParams()
  const insuranceParams = ip as InsuranceParamsTravelDto
  const { mutateAsync: updateInsuranceStartDate } = useUpdateInsuranceStartDate(insuranceParamsId!)
  const { recalculateOffers: recalculate, offers } = useOffersTravelContext()

  const { data: dataDestination } = useSelections(SelectionType.TravelDestination)
  const startDate = insuranceParams!.generalParams.insuranceStartDate
  const destination = dataDestination?.data.find(x => x.id == insuranceParams.travel.destination)

  const now = new Date()

  const isDateInvalid = startDate
    ? new Date(startDate) < toDate(now)!
    : true

  const [isSavingInsruanceStartDate, setIsSavingInsruanceStartDate] = useState(false)
  const handleSetStartDate = (date: Date) => {
    setIsSavingInsruanceStartDate(true)

    updateInsuranceStartDate(date)
      .then(() => {
        recalculate(offers.map(o => o.offerId), true)

        refetchInsuranceParams() // aby se updatnul header
      })
      .finally(() => setIsSavingInsruanceStartDate(false))
  }

  return (
    <>
      <Grid
        sx={{
          gap: isScrolled ? 0 : 1,
          gridAutoFlow: 'column',
          gridTemplateColumns: 'repeat(3, 1fr)',
        }}
      >
        <InsuranceInfoFormControl
          label="Počátek pojištění"
          value={moment(startDate).format('D. M. YYYY')}
          hasError={!isDisabled && isDateInvalid}
          errorMessage={!isDisabled && isDateInvalid ? 'Datum nesmí být v minulosti' : null}
          leftControl={
            <>
              {!isDisabled && currentStepId == 2 &&
                <Button variant="unstyled" size="sm">
                  {!isSavingInsruanceStartDate &&
                    <DatepickerPopup
                      date={now}
                      onDateChange={(date: Date) => handleSetStartDate(date)}
                      dateMin={new Date(now.toDateString())}
                      iconProps={{
                        color: isDateInvalid ? 'red.500' : 'insurance-info-value-color'
                      }}
                    />}
                  {isSavingInsruanceStartDate && <Spinner color={isDateInvalid ? 'red.500' : 'insurance-info-value-color'} />}
                </Button>
              }
            </>
          }
        />

        {insuranceParams?.travel.insuranceEndDate &&
          <InsuranceInfoFormControl
            label="Konec pojištění"
            value={moment(insuranceParams.travel.insuranceEndDate).format('D. M. YYYY')}
          />
        }

        {destination &&
          <InsuranceInfoFormControl
            label="Destinace"
            value={destination.description}
          />
        }
      </Grid>
    </>
  )
}
